<template>
  <v-container class="pt-0" data-qa="accountview-container-q3o0r">
    <!-- <v-tabs
      v-model="currentTab"
      grow
      background-color="#EEEEEE"
      color="deep-purple accent-4"
     data-qa="accountview-tabs-ms2jd">
      <v-tab @change="setTab('savings')" class="text-none" to="/savings" data-qa="accountview-tab-7w3eu">{{ $t('common.savingsLabel') }}</v-tab>
      <v-tab @change="setTab('current')" class="text-none" to="/current" data-qa="accountview-tab-8n8qni">{{ $t('common.currentLabel') }}</v-tab>
      <v-tab @change="setTab('deposits')" class="text-none" to="/deposits" data-qa="accountview-tab-xcbrgr">{{ $t('common.depositsLabel') }}</v-tab>
    </v-tabs> -->
    <!-- Loads the respective tab component -->
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: 'Accounts',
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      currentTab: null
    }
  },
  created () {
    this.setTab(this.$route.name)
  },
  methods: {
    setTab (routeTo) {
      if (routeTo) {
        this.currentTab = (routeTo === 'deposits' || routeTo === 'Deposits') ? 2 : ((routeTo === 'current' || routeTo === 'Current') ? 1 : 0)
      }
    }
  }
}
</script>
